let _ = require('lodash');
let priceActions = require('../order/price');
let { thenWithErrorHandling } = require('../../helpers/errorHandler');

const PATHS = {
    showPriceMustBeBiggerThanZero: ['account', 'orders', 'currentOrder', 'tooltips', 'showPriceMustBeBiggerThanZero'],
    showBillDocumentMustBeAttached: ['account', 'orders', 'currentOrder', 'tooltips', 'showBillDocumentMustBeAttached'],
    showUploadFailTooltip: ['account', 'orders', 'currentOrder', 'tooltips', 'showUploadFailTooltip'],
    orderAmount: ['account', 'orders', 'currentOrder', 'amount'],
    orderAmountError: ['account', 'orders', 'currentOrder', 'errors', 'amount'],
    isExportResultMustBeAttached: ['account', 'orders', 'currentOrder', 'tooltips', 'isExportResultMustBeAttached'],
    isShowUploadResultFailTooltip: ['account', 'orders', 'currentOrder', 'tooltips', 'showUploadResultFailTooltip']
};

module.exports = {
    PATHS,

    getSelectedParamsFromCurrentOrder (args, state, output) {
        let selectedParameters = state.get(['account', 'orders', 'currentOrder', 'selectedParameters']);
        output.success({ selectedParameters });
    },

    updateSelectedParamsForCurrentOrder (args, state, output, { context, locator }) {
        let orderId = state.get(['account', 'orders', 'currentOrder', 'id']);
        let selectedParameters = priceActions.getSelectedParameters(state);
        let api = locator.resolve('api');
        let request = api.updateOrderParameters(context, locator, { orderId, selectedParameters });
        request
            .then((response) => {
                let code = _.get(response, 'status.code');
                if (code !== 200) {
                    output.error({ error: code });
                    return;
                }
                let content = _.get(response, 'content');
                output.success(content);
            })
            .catch((error) => output.error({ error }));
    },

    updateOrder (updateFields) {
        return function updateOrder (args, state) {
            _.forEach(updateFields, function (field) {
                // цена не может стать null
                if (field === 'price' && !_.get(args, 'price')) {
                    return;
                }
                state.set(['account', 'orders', 'currentOrder', field], _.get(args, field));
            });
            let isStateUpdated = _.indexOf(updateFields, 'stateId') > -1;
            let isNameUpdated = _.indexOf(updateFields, 'name') > -1;

            if (isStateUpdated || isNameUpdated) {
                let ordersList = state.get(['account', 'orders', 'list', 'data']);
                let orderId = state.get(['account', 'orders', 'currentOrder', 'id']);
                let orderIndex = _.findIndex(ordersList, { id: orderId });
                if (orderIndex > -1) {
                    if (isStateUpdated) {
                        state.set(['account', 'orders', 'list', 'data', orderIndex, 'stateId'], _.get(args, 'stateId'));
                    }
                    if (isNameUpdated) {
                        state.set(['account', 'orders', 'list', 'data', orderIndex, 'name'], _.get(args, 'name'));
                    }
                }
            }
        };
    },

    filterOptionalExportColumnsOnOrderDisable (args, state) {
        let columns = state.get(['order', 'originalParameters', 'exportColumns', 'columns']);
        let values = state.get(['order', 'computed', 'exportColumns', 'optional', 'value']);
        let isOrderDisabled = state.get(['order', 'isDisabled']);
        let columnsFiltered = _.filter(columns, (x) => x.isBasic === true ||
            (!isOrderDisabled || (values.hasOwnProperty(x.id) && values[x.id].IsChecked === true)));
        state.set(['order', 'originalParameters', 'exportColumns', 'columns'], columnsFiltered);
    },

    setPriceFromOrder (args, state) {
        state.set(['account', 'orders', 'currentOrder', 'price'], state.get(['order', 'price', 'data']));
    },

    getDocumentTypes (args, state, output, { context, locator }) {
        let api = locator.resolve('api');
        let request = api.getDocumentTypes(context, state, {});

        thenWithErrorHandling(
            request,
            (data) => ({ necessaryDocuments: _.get(data, 'content') }),
            output);
    },

    isNeedToGetExportResults (args, state, output) {
        if (state.get(['account', 'orders', 'computed', 'componentsState', 'getExportResults'])) {
            output.yes();
            return;
        }
        output.no();
    },

    /**
     * Периодически пытаемся получить результаты выгрузки (каждые 10 секунд)
     * @param args
     * @param state
     * @param output
     * @param locator
     * @param context
     */
    getExportResults (args, state, output, { locator, context })
    {
        let orderId = state.get(['account', 'orders', 'currentOrder', 'id']);
        let API = locator.resolve('api');

        setTimeout(function exportResultsRetry() {
            // если собираемся запросить результаты для одного заказа, а пользователь уже работает с другим
            // то ничего не делаем
            if (state.get(['account', 'orders', 'currentOrder', 'id']) !== orderId) {
                output.orderChanged();
                return;
            }

            let request = API.getExportResults(context, locator, orderId);
            request.then((data) => {
                // если запросили результаты для одного заказа, а пользователь уже работает с другим
                // то ничего не делаем
                if (state.get(['account', 'orders', 'currentOrder', 'id']) !== orderId) {
                    output.orderChanged();
                    return;
                }

                let statusCode = _.get(data, 'status.code');

                // 404 это обычное дело, ждём пока стастика появится
                if (statusCode === 404) {
                    setTimeout(exportResultsRetry, 10000);
                    return;
                }

                // но может быть какая-та ошибка сервера, тогда сворачиваемся
                if (statusCode !== 200) {
                    output.error({ error: statusCode });
                    return;
                }

                output.success({ exportResult: _.get(data, 'content.results'),
                    hasBitrixLeads: _.get(data, 'content.hasBitrixLeads') });
            }).catch((error) => {
                output.error({ error });
            });
        }, 0);
    },

    getOrderState (args, state, output, { locator, context }) {
        let API = locator.resolve('api');
        let timerId = setTimeout(function getState () {
            if (state.get(['account', 'orders', 'currentOrder', 'stateId']) !== 3) {
                output.dontNeed();
                return;
            }

            let orderId = state.get(['account', 'orders', 'currentOrder', 'id']);
            let request = API.getOrderState(context, locator, orderId);
            request.then((data) => {
                // если запросили статус для одного заказа, а пользователь уже работает с другим, то делаем новый запрос
                if (state.get(['account', 'orders', 'currentOrder', 'id']) !== orderId) {
                    timerId = setTimeout(getState, 0);
                    return;
                }

                let statusCode = _.get(data, 'status.code');
                if (statusCode !== 200) {
                    output.error({ error: statusCode });
                    return;
                }

                let stateId = _.get(data, 'content');
                if (stateId !== 3) {
                    output.success({ stateId });
                } else {
                    timerId = setTimeout(getState, 10000);
                }
            }).catch((error) => {
                output.error({ error });
            });
        }, 0);
    },

    /**
     * Переодическое обновление флага HasBitrixLeads, ждём пока он станет true
     * Флаг показывает, что для заказа были выгружены лиды, а значит можно сделать Бесплатную пробную выгрузку, например
     * @param args
     * @param state
     * @param output
     * @param locator
     * @param context
     */
    getHasBitrixLeads (args, state, output, { locator, context }) {
        let API = locator.resolve('api');
        setTimeout(function getIsExportResultReady () {
            // обновление флага имеет смысл только для Битрикса, если у пользователя есть право на халяву
            // и заказа в статусе "Ожидаетет оплату"
            if (state.get(['bitrix', 'isBitrix']) !== true ||
                state.get(['account', 'orders', 'currentOrder', 'stateId']) !== 3 ||
                state.get(['user', 'isFreeBitrixExportAllowed']) !== true) {
                output.dontNeed();
                return;
            }

            let orderId = state.get(['account', 'orders', 'currentOrder', 'id']);
            let request = API.getHasBitrixLeads(context, locator, orderId);
            request.then((data) => {
                // если запросили статус для одного заказа, а пользователь уже работает с другим, то делаем новый запрос
                if (state.get(['account', 'orders', 'currentOrder', 'id']) !== orderId) {
                    setTimeout(getIsExportResultReady, 0);
                    return;
                }

                let statusCode = _.get(data, 'status.code');
                if (statusCode !== 200) {
                    output.error({ error: statusCode });
                    return;
                }

                if (_.get(data, 'content') === true) {
                    output.success({ hasBitrixLeads: true });
                } else {
                    setTimeout(getIsExportResultReady, 10000);
                }
            }).catch((error) => {
                output.error({ error });
            });
        }, 0);
    },

    /**
     * Ждём когда бекенд установит релиз и будет готов нормально двигать заказы по статусам
     * @param args
     * @param state
     * @param output
     * @param locator
     * @param context
     */
    waitBackendStandardState(args, state, output, { locator, context })
    {
        let API = locator.resolve('api');

        let timerId = setTimeout(function waitWorkingRetry() {
            let request = API.isBackendInStandardState(context, locator);
            request.then((data) => {
                let statusCode = _.get(data, 'status.code');
                if (statusCode !== 200) {
                    output.error({ statusCode: code });
                    return;
                }

                // елси бекенд не готов, ждём
                if(_.get(data, 'content') !== true) {
                    timerId = setTimeout(waitWorkingRetry, 10000);
                    return;
                }

                output.success();
            }).catch((error) => {
                output.error({ error });
            });
        }, 0);
    },

    addCurrentOrderToList (args, state) {
        let id = state.get(['account', 'orders', 'currentOrder', 'id']);
        let list = state.get(['account', 'orders', 'list', 'data']);
        if (_.findIndex(list, { id: id }) !== -1) {
            return;
        }
        let listItem = {
            id: id,
            createDate: state.get(['account', 'orders', 'currentOrder', 'createDate']),
            stateId: state.get(['account', 'orders', 'currentOrder', 'stateId']),
            typeId: state.get(['account', 'orders', 'currentOrder', 'typeId'])
        };
        let newList = _.cloneDeep(list);
        newList.unshift(listItem);
        state.set(['account', 'orders', 'list', 'data'], newList);
    }
};



// WEBPACK FOOTER //
// ./actions/account/current-order.js